export interface SettingHistoryFilters {
  category: string[];
  page?: number;
  limit?: number;
}

export interface ResponseSettingHistory {
  _id: string;
  menu: string;
  tab: string;
  api: string;
  action: string;
  status: string;
  createdAt: string;
  updatedAt: string;
  createdBy: string;
  updatedBy: string;
  changedFields: {
    field: string;
    oldValue: any;
    newValue: any;
    changes: any;
  }[];
  lastValue: object;
  recentValue: object;
  createdRecords: any;
  updatedRecords: any;
}

export interface FullyResponseSettingHistory {
  data: ResponseSettingHistory[];
  total: number;
}

export enum FILTER_VALUE_EACH_TABS {
  MASTER_DATA = `["master_fugitive", "master_tank", "master_transportation_marketing", "master_waste_water", "master_combustion", "master_flare"]`,
  COMPANY = `["company"]`,
  USER_MANAGEMENT = `["master_user_management"]`,
  JOB = `["job_schedule"]`,
}

export interface ResponseGetDistinctSettingHistory {
  createdBy: GroupDistinctColumn[];
  action: GroupDistinctColumn[];
}

export interface GroupDistinctColumn {
  text: string;
  value: string;
}

export enum SETTING_HISTORY_TAB {
  MASTER_DATA = "master_data",
  COMPANY = "company",
  USER_MANAGEMENT = "user_management",
  JOB = "job",
}

export interface FilterDistinctSettingHistory {
  tab: SETTING_HISTORY_TAB;
}
